export const ENDPOINT_OFFERS_HOME = '/api/v1/offers/home-page';
export const ENDPOINT_OFFERS_GET_ALL = '/api/v1/offers/list';
export const ENDPOINT_OFFERS_GET_ONE = '/api/v1/offers/one';
export const ENDPOINT_OFFERS_CATEGORIES = '/api/v1/offers/categories/list';
export const ENDPOINT_OFFERS_SEARCH = '/api/v1/offers/search';
export const ENDPOINT_OFFERS_ADD_FAVORITES = '/api/v1/offers/save';
export const ENDPOINT_OFFERS_REMOVE_FAVORITES = '/api/v1/offers/unsave';
export const ENDPOINT_OFFERS_BANNER = '/api/v1/contents/list';
